import { useEffect, useState } from 'react';
import useAuth from './useAuth';

export default function useIsAuthing() {
  const [{ authed, loading }, setState] = useState({
    authed: false,
    loading: true,
  });

  const auth = useAuth();

  useEffect(
    () =>
      auth().onAuthStateChanged(user => {
        if (user) {
          setState({
            authed: true,
            loading: false,
          });
        } else {
          setState({
            authed: false,
            loading: false,
          });
        }
      }),
    [],
  );

  return [authed, loading];
}
